// node_modules
import React from "react";

// components
import { MenuItemInfoIcon } from "./MenuItemInfoIcon";

// styles
import * as styles from "./MobileSelectModal.module.css";

export const MobileSelectItem = ({
  label,
  image,
  active,
  onClick,
  infoOptionId,
  infoItemName,
}) => {
  return (
    <div
      className={`${styles.item} ${active ? styles.active : ""}`}
      onClick={onClick}
    >
      <div className={styles.itemImage}>
        {image && <img src={image} alt={label} width={56} height={56} />}
      </div>
      <span className={styles.itemLabel}>{label}</span>
      <MenuItemInfoIcon optionId={infoOptionId} itemName={infoItemName || label} />
    </div>
  );
};
